import React, { useEffect } from "react";
import { Stack, Alert, Slide, AlertTitle } from "@mui/material";
import { useConfigStore, useMessageStore } from "../../store/store";
import { MessageStore } from "../../store/types";
import styles from "./AlertWindow.module.css";
import { getTraceId } from "../../utils";


export const AlertWindow: React.FC = () => {
    const { messages, removeMessage } = useMessageStore((state: MessageStore) => state);
    const appInsights = useConfigStore((state) => state.appInsights);

    useEffect(() => {
        if (messages.length > 0) {
            const timer = setTimeout(() => {
                removeMessage(0);
            }, 5_000);
            return () => clearTimeout(timer);
        }
    }, [messages, removeMessage]);

    return (
        <Stack className={styles.container} spacing={2}>
            {messages.map((alert, idx) => (
                <Slide direction="up" in mountOnEnter unmountOnExit key={idx}>
                    <Alert severity={alert.type} variant="filled">
                        <AlertTitle>{alert.type.charAt(0).toUpperCase() + alert.type.slice(1)}</AlertTitle>
                        {String(alert.message).substring(0, 200)}
                        {getTraceId(appInsights) !== "not_present" && (
                            <p>
                                TraceId: {getTraceId(appInsights)}
                            </p>
                        )}
                    </Alert>
                </Slide>
            ))}
        </Stack>
    );
};
